<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >supervised_user_circle</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.frontuser' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->


      <div>
        @if (!hideButton) {
          <button mat-raised-button
            [routerLink]="'/pages/frontUser/new'"
            class="add-product-button mat-white-bg my-12 mt-sm-0">
            <span>{{'frontUser.add_new_user' | translate}}</span>
          </button>
        }

        @if (!hideButton) {
          <button mat-raised-button (click)="openBookModal()" [disabled]="!checkedUsers.length"
            class="add-product-button mat-white-bg my-12 mt-sm-0">
            <span>{{'frontUser.book_event' | translate}}</span>
          </button>
        }

        @if (!hideButton) {
          <button mat-raised-button (click)="openImportModal()"
            class="add-product-button mat-white-bg my-12 mt-sm-0">
            <span>{{'frontUser.import_modal' | translate}}</span>
          </button>
        }
        <button mat-raised-button (click)="download()"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'exportUser' | translate}}</span>
        </button>

        <mat-button-toggle-group #group="matButtonToggleGroup" class="communication-action"
          [value]="selectedVal"
          [disabled]="!checkedUsers.length" (change)="communicationAction($event)">
          @if (eCall) {
            <mat-button-toggle value="sms" [disabled]="!checkedUsers.length" matTooltip="SMS">
              <mat-icon>textsms</mat-icon>
            </mat-button-toggle>
          }
          @if (whatsapp) {
            <mat-button-toggle value="whatsapp"  matTooltip="WhatsApp">
              <mat-icon>call</mat-icon>
            </mat-button-toggle>
          }
          <mat-button-toggle value="mail" [disabled]="!checkedUsers.length" matTooltip="MAIL">
            <mat-icon>email</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="serial" [disabled]="!checkedUsers.length" matTooltip="{{'frontUser.Serial_Letter' | translate}}">
            <mat-icon>receipt</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="emailList"  matTooltip="{{'frontUser.emailList' | translate}}">
            <mat-icon>forward_to_inbox</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="hide" [hidden]="true">
            <mat-icon>hide</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>


        <button mat-button class="mat-icon-button sidenav-toggle mr-12"
          fuseMatSidenavToggler="user-main-sidenav"
          fxHide.gt-lg>
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <mat-sidenav-container class="my-sidenav" style="  position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: transparent;">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
                   fuseMatSidenavHelper="user-main-sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
        <filter-menu [filters]="filterData" [page]="'user'" [filterFromDB]="userFilters"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="content-card mat-white-bg"
      [ngClass]="{'margin-big-screen': sidenav.opened}">

      <mat-table class="products-table"
        #table [dataSource]="users"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar
        (scroll)="onScroll($event)"
        id="frontUserPage">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *cdkHeaderCellDef style="padding: 15px !important;flex: 0 0 30px;">
            <mat-checkbox (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *cdkCellDef="let row" style="padding: 0px !important;flex: 0 0 30px;">
            <mat-checkbox (click)="$event.stopPropagation()" style="padding: 14px !important;"
              (change)="$event ? selection.toggle(row) : null; checkUser(row, $event)"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>


        <ng-container cdkColumnDef="logo">
          <mat-header-cell *cdkHeaderCellDef [ngClass]="'customWidthClassImage'"></mat-header-cell>
          <mat-cell *cdkCellDef="let user" [ngClass]="'customWidthClassImage'">
            @if (user.logo && user.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"  class="user-photo"
                [src]="getImage(user.logo)"/>
            }
            @if (!user?.showFoto || (user?.showFoto && !user?.logo && user?.gender === 'diverse')) {
              <div [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}" class="user-photo color-logo"
                [style.backgroundColor]="(user?.logoColor && !user?.showFoto )? user?.logoColor : '#B0B0B0'">
                {{user.firstName[0].toUpperCase()}}{{user.lastName[0].toUpperCase()}}
              </div>
            }
            @if (!user.logo && user.frontRole.name === 'student' && user.gender === 'male' && user?.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"   class="user-photo" [src]="'assets/images/studentMale.jpg'">
            }
            @if (!user.logo && user.frontRole.name === 'student' && user.gender === 'female' && user?.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"   class="user-photo" [src]="'assets/images/studentFemale.jpg'">
            }
            @if (!user.logo && user.frontRole.name === 'parent' && user.gender === 'female' && user?.showFoto) {
              <img  [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"  class="user-photo" [src]="'assets/images/mother.jpg'">
            }
            @if (!user.logo && user.frontRole.name === 'parent' && user.gender === 'male' && user?.showFoto) {
              <img [ngClass]="{'active-user':user.activated, 'noactive-user':!user.activated}"   class="user-photo" [src]="'assets/images/father.jpg'">
            }
            @if (user.frontRole.name === 'student') {
              <p class="front-role" style="color:green">S</p>
            }
            @if (user.gender === 'male') {
              <p class="front-member" >M</p>
            }
            @if (user.gender === 'female') {
              <p class="front-member" >F</p>
            }
            @if (user.gender === 'diverse') {
              <p class="front-member" >D</p>
            }
            @if (user.frontRole.name === 'parent') {
              <p class="front-role" style="color:blue">E</p>
            }

          </mat-cell>
        </ng-container>
        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let user">
            <p class="text-truncate">{{user.firstName}} {{user.lastName}} </p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="email">
          <mat-header-cell [ngClass]="'customWidthClass'"  *cdkHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell [ngClass]="'customWidthClass'"  *cdkCellDef="let user">
            @if (user.email) {
              <mat-icon style="    margin: 5px;">contact_mail</mat-icon>
            }
          </mat-cell>
        </ng-container>
        <ng-container cdkColumnDef="sms">
          <mat-header-cell [ngClass]="'customWidthClass'"  *cdkHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell [ngClass]="'customWidthClass'"  *cdkCellDef="let user">
            @if (user.mobile) {
              <mat-icon style="    margin: 5px;">contact_phone</mat-icon>
            }
          </mat-cell>
        </ng-container>
        <ng-container cdkColumnDef="address">
          <mat-header-cell [ngClass]="'customWidthClass'"  *cdkHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell [ngClass]="'customWidthClass'"  *cdkCellDef="let user">
            @if (user.street && user.cityLocation && user.postcode) {
              <mat-icon style="    margin: 5px;">email</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="sendInvite">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.sendInvite' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let user">
            @if (user.sendInvite && user.email) {
              <mat-icon class="active">contact_mail</mat-icon>
            }
            @if (!user.sendInvite && user.email) {
              <mat-icon class="no_active">contact_mail</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <!-- Code Column -->
        <!--<ng-container cdkColumnDef="code">-->
        <!--<mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.code' | translate}}</mat-header-cell>-->
        <!--<mat-cell *cdkCellDef="let canton">-->
        <!--<p class="text-truncate">{{canton.code}}</p>-->
      <!--</mat-cell>-->
    <!--</ng-container>-->
    <ng-container cdkColumnDef="role">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.role' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontRole) {
          <p  class="text-truncate">{{user.frontRole.name}}</p>
        }
      </mat-cell>
    </ng-container>

    @if (!isOrganizer) {
      <ng-container cdkColumnDef="country">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.country' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let user">
          <img style="height: 40px" [src]="'assets/images/' + user.country.flag + '.svg'"/>
        </mat-cell>
      </ng-container>
    }

    @if (!isOrganizer) {
      <ng-container cdkColumnDef="canton">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.canton' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let user">
          @if (user.city) {
            <p  class="text-truncate">{{user.city.name}}</p>
          }
        </mat-cell>
      </ng-container>
    }
    <ng-container cdkColumnDef="targetGroup">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.targetGroup' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.targetGroup) {
          <p  class="text-truncate">{{user.targetGroup.abbreviation ? user.targetGroup.abbreviation + user.targetGroup.targetNumber : user.targetGroup.ageMask}}</p>
        }
      </mat-cell>
    </ng-container>

    @if (!isOrganizer) {
      <ng-container cdkColumnDef="organization">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'user.organization' | translate}}</mat-header-cell>
        <mat-cell *cdkCellDef="let user">
          @if (user.organization) {
            <p class="text-truncate">{{user.organization.name}}</p>
          }
        </mat-cell>
      </ng-container>
    }
    <ng-container cdkColumnDef="connection">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'dashboard.clan' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.frontRole.name === 'student') {
          <div>
            @if (user.godMotherId || user.godFatherId || user.motherId || user.fatherId) {
              <img style="height: 40px" [src]="'assets/images/hasParent.svg'"/>
            }
            @if (!user.godMotherId && !user.godFatherId && !user.motherId && !user.fatherId) {
              <div> <img style="height: 40px" [src]="'assets/images/noParent.svg'"/></div>
            }
          </div>
        }

      </mat-cell>
    </ng-container>

    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let user; columns: displayedColumns;"
      class="product"
      matRipple
      [routerLink]="'/pages/frontusers/detail'" [queryParams]="{id: user.id}">
    </mat-row>

  </mat-table>
  @if (users.filteredData.length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{'main.noData' | translate}}</span>
    </div>
  }
  <mat-paginator #paginator
    [length]="users.filteredData.length"
    [pageIndex]="_pageIndex"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]"
    (page)="changePageEmitter($event)">
  </mat-paginator>

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
